import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./AdminMenu.css";
import MenuRow from "../../Components/MenuRow/MenuRow";
import AdminNav from "../../Components/AdminNav.jsx/AdminNav";
import axios from "axios";
import MenuFilter2 from "../../Components/MenuFilter/MenuFilter2";

const AdminMenu = () => {
  const [menuItems, setMenuItems] = useState([]);
  const [displayMenuItems, setDisplayMenuItems] = useState([]);
  const  [ogMenu, setOGMenu] = useState([]);
   const [loading, setLoading] = useState(true);
   const [bizCategories, setBizCategories] = useState([]);
   const [currentBizCategories, setCurrentBizCategories] = useState([]);
 
   useEffect(() => {
     const orderQueue = (list) => {
       let queue = list;
        setDisplayMenuItems(queue);
        setOGMenu(queue);
        const categoriesSet = [
         ...new Set(
           queue.map((bizItem) => bizItem.category.toUpperCase())
         ),
       ];
       setBizCategories(categoriesSet);
       setCurrentBizCategories(categoriesSet);
       setLoading(false)
     };
     const initializeMenu = async () => {
      try {
        const response = await axios.get("/services");
       orderQueue(response.data)
      } catch (err) {
        console.log(err);
        setLoading(false);
      }
    };
    initializeMenu();
    //  eslint-disable-next-line
   }, []);
 
   const filterBizByCategory = (category) => {
     if (category === "ALL") {
       setCurrentBizCategories(bizCategories);
       setDisplayMenuItems(ogMenu)
     } else {
       setCurrentBizCategories([category]);
       let queue = ogMenu;
       const queueFilter = queue.filter(item => item.category.toUpperCase() === category);
       setDisplayMenuItems(queueFilter)
     }
   };

  const handleDelete = (id) => {
    axios.delete(`/services/${id}`)
      .then((res) => window.location.reload())
      .catch((err) => console.log(err));
  };

  const handleReset = () => {
    setDisplayMenuItems(menuItems);
  };

 if (loading) return null;
  return (
    <>
      <AdminNav/>
      <MenuFilter2
        menuCategories={bizCategories}
        handleClick={filterBizByCategory}
      />
      <div className="container">
        
          <div className="row">
            <div className="col s12">
              <h3 className="admin-title center-align">MY SERVICES</h3>
            </div>
            <div className="row center-align">
            <div className="col s8 input-field">
                <input
                  id="searchTerm"
                  type="text"
                  className="validate foodFormInput"
                  name="searchTerm"
                  placeholder="Search Service"
                 
                  onChange={(e) => {
                  
                    let searchVar = "";
                    searchVar = searchVar.concat(e.target.value)
                   
                    const searchedItems = menuItems.filter(
                      (item) => {
                        return item.title.toLowerCase().includes(searchVar.toLowerCase());
                      }
                    );
                    setDisplayMenuItems(searchedItems);
                  }}
                ></input>
              </div>
              <div className="col s4 menuFilterButtons">
                <Link to="/admin/menu/add">
                  <button className="btn waves-effect waves-light submit-button">
                    Add Service
                  </button>
                </Link>
              </div>
 
            </div>
          </div>
          <div className="row">
            <div className="admin-menu col s12 blk">
              <table>
                <thead className="table-row">
                  <tr >
                    <th className="table-col">Service</th>
                    <th className="table-col">Description</th>
                    <th className="table-col">Img</th>
                    <th className="table-col">Category</th>
                    <th className="table-col">Price</th>
                    <th className="table-col">Edit</th>
                    <th className="table-col"> Delete</th>
                  </tr>
                </thead>

                <tbody>
                  {displayMenuItems.map(
                    ({ _id, title, description, rating, img, category }) => (
                      <MenuRow
                        _id={_id}
                        title={title}
                        description={description}
                        rating={rating}
                        img={img}
                        category={category}
                        handleDelete={handleDelete}
                      />
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>
       
      </div>
    </>
  );
};

export default AdminMenu;
